export default {"src":"/_next/static/media/crossButton.b8614cf0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};